export enum FILE_EXPORT_TYPE {
  NONE = '',
  CSV = 'text/csv',
  TXT = 'text/plain',
}
